import { type GlobalToken, Grid, QRCode, theme, Typography } from "antd";
import { createStyles } from "antd-style";

import { Button } from "@rumbledirect/ui";
import { ExternalLinkIcon } from "../registrations/icons/ExternalLinkIcon";

const useStyles = createStyles(
  ({ css }, { themeToken }: { themeToken: GlobalToken }) => ({
    primaryButton: css`
      color: ${themeToken.Button?.primaryColor || "#ffffff"} !important;
      padding: 0 28px;
      font-size: 18px;
      font-weight: 700;
    `,
  }),
);

const { useBreakpoint } = Grid;

interface ExternalLinkActionsProps {
  externalLink: string;
}

export const ExternalLinkActions = ({
  externalLink,
}: ExternalLinkActionsProps) => {
  const { token } = theme.useToken();
  const { styles } = useStyles({ themeToken: token });
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <div style={{ marginTop: 16 }}>
      {isMobile ? (
        <>
          <Typography.Paragraph
            style={{
              marginBottom: 24,
              fontSize: 15,
              fontWeight: 500,
              color: "#555",
            }}
          >
            Maak foto&apos;s van de schade en upload deze via de onderstaande
            link. De link opent in een externe pagina.
          </Typography.Paragraph>

          <Button
            type="primary"
            size="large"
            href={externalLink}
            target="_blank"
            rel="noreferrer"
            className={styles.primaryButton}
          >
            Upload foto&apos;s
            <ExternalLinkIcon size={16} />
          </Button>
        </>
      ) : (
        <>
          <Typography.Paragraph
            style={{
              marginBottom: 24,
              fontSize: 15,
              fontWeight: 500,
              color: "#555",
            }}
          >
            Scan de QR-code om foto&apos;s van de schade te maken en uploaden.
          </Typography.Paragraph>

          <QRCode style={{ margin: "auto" }} value={externalLink} size={200} />
        </>
      )}
    </div>
  );
};
